<template>
  <div>
    <validationObserver v-slot="{ handleSubmit }">
      <b-form @submit.prevent="handleSubmit(submitForm)">
        <b-row>
          <b-col md="6">
            <b-form-group label="Start date" label-for="Start date" >
              <flatPickr
                  :config="{ minDate: 'today' }"
                  :class="['form-control bg-white']"
                  v-model="dates.start_date"
                  placeholder="Start date"
              />
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group label="End date" label-for="End date" >
              <flatPickr
                  :config="{ minDate: dates ? dates.start_date : ''}"
                  :class="['form-control bg-white']"
                  v-model="dates.end_date"
                  placeholder="End date"
              />
            </b-form-group>
          </b-col>

        </b-row>

        <!-- Submit -->
        <b-row>
          <b-col md="12" class="mt-4">
            <div class="d-flex justify-content-center">
              <b-button :class="`button-orange-modal`" type="submit">
                <i v-if="!requestLoading" class="las la-plus"></i>
                <spinner-loading v-else></spinner-loading>
              </b-button>
            </div>
          </b-col>
        </b-row>

      </b-form>
    </validationObserver>
  </div>
</template>

<script>
import flatPickr from 'vue-flatpickr-component'

export default {
  components: {
    flatPickr
  },
  props: {
    requestLoading: {
      type: Boolean,
      default: false
    },
    typeOfModal: { type: String, default: 'add' }
  },

  data () {
    return {
      dates: {
        start_date: '',
        end_date: ''
      }
    }
  },

  methods: {

    submitForm () {
      this.$emit('submit', this.dates)
    }
  }

}
</script>

<style scoped>
</style>